export default __webpack_public_path__ + "static/media/ciclo-de-conferencias__banner_sinboton.c8ed64f3.jpg";